export type ExportJobResponse = {
  id: string;
  createdBy: string;
  completionPercent: number;
  createdTimestamp: number;
  completedTimestamp: number;
  query: string;
  label: string;
  status: JOB_STATUS;
  timeRange: ExportTimeRange;
  s3Bucket: string;
  filenamePrefix: string;
  recipients: string[];
  output: JOB_OUTPUT;
};

export type ExportJobTableData = {
  id: string;
  createdBy: string;
  completionPercent: number;
  createdTimestamp: number;
  query: string;
  label: string;
  status: string;
  timeRangeStart: string;
  timeRangeEnd: string;
  s3Bucket: string;
  filenamePrefix: string;
  recipients: string[];
  output: string;
};

export type ExportJobTable = {
  id: string;
  createdBy: string;
  createdTimestamp: number;
  name: string;
  status: string;
  time: string;
  s3Bucket: string;
  filenamePrefix: string;
  recipients: string[];
  output: string;
};

export type ExportTimeRange = {
  min: number;
  max: number;
};

export enum JOB_OUTPUT {
  PLAIN_TEXT = 'PLAIN_TEXT',
  JSON = 'JSON',
}
export const JobOutput = {
  PLAIN_TEXT: 'Text',
  JSON: 'JSON',
};
export enum JOB_STATUS {
  PENDING = 'PENDING',
  WORKING = 'WORKING',
  COMPLETE = 'COMPLETE',
  CANCEL_REQ = 'CANCEL_REQ',
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
  NO_DATA = 'NO_DATA',
}

export const JobStatus: Record<string, string> = {
  PENDING: 'Pending',
  WORKING: 'Working',
  COMPLETE: 'Complete',
  CANCEL_REQ: 'Cancel Request',
  CANCELED: 'Canceled',
  FAILED: 'Failed',
  NO_DATA: 'No data in the storage',
};

export type ExportJobFormData = {
  timeRangeStart: string;
  timeRangeEnd: string;
  query: string;
  label: string;
  s3Bucket: string;
  filenamePrefix: string;
  recipients: string[];
};

export type ExportJobsList = {
  listJobs: ExportJobResponse[];
};

export type AddJobData = {
  timeRangeStart: string;
  timeRangeEnd: string;
  query: string;
  s3Bucket: string;
  output: JOB_OUTPUT;
  label?: string;
  filenamePrefix?: string;
  recipients?: string[];
};

export type AddJobVariables = {
  job: AddJobData;
};

export type CancelJobVariables = {
  jobId: string;
};
